import { Pipe, PipeTransform } from '@angular/core';

import { crossSells } from '../cross-sell';

@Pipe({
    name: 'crossSell'
})
export class CrossSellPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = crossSells.findIndex(crossSell => crossSell.id === value);
        if (index > -1) {
            return crossSells[index].nome;
        }

        return '';
    }
}
